import { render, staticRenderFns } from "./SnackBar.vue?vue&type=template&id=e2e8fae4"
import script from "./SnackBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SnackBar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports